interface GenderSwitchButtonProps {
  label: 'Masculino' | 'Feminino'
  isSelected: boolean
  onClick: () => void
  getButtonClassName: (isSelected: boolean) => string
  testId: 'gender-switch-men' | 'gender-switch-women'
}

export function GenderSwitchButton({
  label,
  isSelected,
  onClick,
  getButtonClassName,
  testId,
}: Readonly<GenderSwitchButtonProps>) {
  return (
    <button
      type="button"
      aria-label={label}
      aria-pressed={isSelected}
      disabled={isSelected}
      data-testid={testId}
      onClick={onClick}
      className={`h-10 flex-1 rounded-full text-xs leading-5 font-semibold transition-colors ${getButtonClassName(
        isSelected
      )}`}
    >
      {label}
    </button>
  )
}
